import { useEffect, useMemo, useState } from "react";

import ApontamentoAmostraParams, {
    useTipoApontamento,
} from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";
import ApontamentoResultado from "entity/Indicador/components/apontamento/fields/ApontamentoResultado";
import ApontamentoColetas from "entity/Indicador/components/apontamento/fields/ApontamentoColetas";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams";

import { useFieldPrefix, useFieldValue } from "components/form/input/NestedField";
import { Field, useForm } from "react-final-form";
import { Autocomplete, TextField } from "@mui/material";
import TextInput from "components/form/input/TextInput";
import FormRow from "components/form/FormRow";
import BasicAccordion from "components/basic/BasicAccordion";
import FormContent from "components/form/FormContent";
import DateInput from "components/form/input/DateInput";
import PSM from "..";
import EntitySearchInput from "components/form/EntitySearch/EntitySearchInput";
import Variedade from "entity/Variedade";

export default function PSMEditFields({ visita, TipoClass }) {
    const [tipo, setTipo] = useTipoApontamento();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const params = useMemo(() => visita.cliente.getParams(PSM, "Manual", TipoClass), [visita.cliente]);
    const [apontamento] = useFieldValue();
    const form = useForm();
    const [talhoes, setTalhoes] = useState([]);
    const talhaoFieldName = useFieldPrefix("talhao");

    useEffect(() => {
        if (tipo !== "Manual") setTipo("Manual");
    }, [setTipo, tipo]);

    useEffect(() => {
        if (apontamento) {
            let conf = PSM.calcConformidade(apontamento, params);
            // apontamento.conformidade = conf
            form.change("totalTocosAtacados", conf.tocosAtacados);
            form.change("totalTocosAvaliados", conf.tocosAvaliados);
            // form.change("conformidade", conf)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, params]);

    useEffect(() => {
        if (visita.fazenda && visita.fazenda.data.talhoesFazenda)
            setTalhoes(["", ...visita.fazenda.data.talhoesFazenda]);
    }, [visita.fazenda]);

    return (
        <>
            <BasicAccordion title="Dados Básicos" defaultExpanded={true} fullWidth disableGutters>
                <FormContent>
                    <FormRow>
                        <DateInput showTime name="date" label="Data / Hora Coleta" disabled />
                    </FormRow>
                    <FormRow>
                        <Field
                            name={talhaoFieldName}
                            validate={(value) => (value && value.length > 0 ? undefined : "Campo obrigatório")}
                            render={({ input, meta }) => (
                                <div style={{ flex: 1 }}>
                                    <Autocomplete
                                        // multiple={input.value?.length ? true : false}
                                        multiple={!input.value || input.value.length ? true : false}
                                        value={input.value || []}
                                        onChange={(_, value) => input.onChange(value)}
                                        options={talhoes}
                                        getOptionLabel={(option) => option.nome || ""}
                                        isOptionEqualToValue={(option, value) => option.nome === value.nome}
                                        sx={{ flex: 1 }}
                                        renderInput={(params) => (
                                            <TextField
                                                label="Talhão"
                                                variant="standard"
                                                {...params}
                                                error={meta.error && meta.touched}
                                                helperText={meta.touched ? meta.error : ""}
                                            />
                                        )}
                                        renderOption={(props, option) => <li {...props}>{option.nome}</li>}
                                    />
                                    {/* {meta.error && meta.touched && (
                                        <span style={{ color: 'red' }}>{meta.error}</span>
                                    )} */}
                                </div>
                            )}
                        />
                    </FormRow>
                </FormContent>
            </BasicAccordion>

            <ApontamentoAmostraParams tipoFixedValue="Manual">
                <FormRow>
                    <EntitySearchInput name="variedade" label="Variedade" EntityClass={Variedade} />
                </FormRow>
                {/* <FormRow>
                    <EntitySearchInput name="insumo" label="Variedade" EntityClass={Insumo} />
                    {TipoClass.field === 'colheitas' && (
                        <EntitySearchInput name="operador" label="Operador" EntityClass={Operador} extraQuery={(query) => query.where("cliente.uid", "==", visita.data.cliente.uid)} />
                    )}
                </FormRow> */}
                <FormRow>
                    <TextInput type="number" name="tocosAvaliados" label="Total de Tocos Avaliados" />
                </FormRow>
            </ApontamentoAmostraParams>

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <ApontamentoParamItem label="Meta (%):">{params.meta}</ApontamentoParamItem>
                    </>
                ) : null}
            </ApontamentoClienteParams>
            <ApontamentoColetas visita={visita} name="coletasTocAt" label="Coletas - Tocos Atacados">
                {/* 
                Cálculo desse será baseado na quantidade de tocos avaliados setado em Parametros da Amostra
                Deverá ser em porcentagem (%) para gerar o gráfico de pizza
                 */}
                <TextInput type="number" name="pragaSphenophorusTocAt" label="Sphenophorus" />
                <TextInput type="number" name="pragaHyponeumaTocAt" label="Hyponeuma" />
                <TextInput type="number" name="pragaMigdolusTocAt" label="Migdolus" />
                <TextInput type="number" name="pragaCupinsTocAt" label="Cupins" />
            </ApontamentoColetas>
            <ApontamentoColetas visita={visita} name="coletasPragEnc" label="Coletas - Pragas Encontradas">
                {/* 
                Cálculo desse será baseado na quantidade de tocos avaliados setado em Parametros da Amostra
                Deverá ser em porcentagem (%) para gerar o gráfico de pizza
                 */}
                <TextInput type="number" name="pragaSphenophorusPragEnc" label="Sphenophorus" />
                <TextInput type="number" name="pragaHyponeumaPragEnc" label="Hyponeuma" />
                <TextInput type="number" name="pragaMigdolusPragEnc" label="Migdolus" />
                <TextInput type="number" name="pragaCupinsPragEnc" label="Cupins" />
            </ApontamentoColetas>

            <ApontamentoResultado showConformidadeField={false}>
                <FormRow>
                    <TextInput name="totalTocosAvaliados" label="Total Avaliado" disabled />
                    <TextInput name="totalTocosAtacados" label="Total Atacado" disabled />
                </FormRow>
            </ApontamentoResultado>

            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
